import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {
  @Input() data!: any
  @Input() isLogoutButton: boolean = false
  @Output() buttonSelected = new EventEmitter<any>()

  constructor() { }

  ngOnInit(): void {
  }

  select() {
    this.data.isButtonSelected = !this.data.isButtonSelected
    this.buttonSelected.emit(this.data)
  }
}
